import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import CloseIcon from "@mui/icons-material/Close";
import { GroupRole } from "../../lib/types";

interface InviteMemberModalProps {
  open: boolean;
  onClose: () => void;
  onInviteByEmail: (email: string, role: Exclude<GroupRole, "owner">) => void;
}

const InviteMemberModal: React.FC<InviteMemberModalProps> = ({
  open,
  onClose,
  onInviteByEmail,
}) => {
  const [email, setEmail] = useState("");
  const [role, setRole] = useState<Exclude<GroupRole, "owner">>("viewer");
  const [inviteError, setInviteError] = useState<string | null>(null);

  const handleSendInvite = () => {
    const trimmedEmail = email.trim();
    if (!trimmedEmail) {
      setInviteError("Email is required.");
      return;
    }
    setInviteError(null);
    console.log("Inviting member by email", { email: trimmedEmail, role });
    onInviteByEmail(trimmedEmail, role);
    setEmail("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Invite a member</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <Typography color="text.secondary">Invite by email.</Typography>
          <FormControl fullWidth>
            <InputLabel id="invite-role-label">Role</InputLabel>
            <Select
              labelId="invite-role-label"
              value={role}
              label="Role"
              onChange={(event) =>
                setRole(event.target.value as Exclude<GroupRole, "owner">)
              }
            >
              <MenuItem value="editor">Editor</MenuItem>
              <MenuItem value="viewer">Viewer</MenuItem>
            </Select>
          </FormControl>
          <Stack direction="row" spacing={1} alignItems="center">
            <TextField
              label="Email"
              value={email}
              onChange={(event) => {
                setEmail(event.target.value);
                if (inviteError) setInviteError(null);
              }}
              fullWidth
              error={Boolean(inviteError)}
              helperText={inviteError || undefined}
            />
            <Tooltip title="Send email invite">
              <IconButton onClick={handleSendInvite}>
                <SendIcon />
              </IconButton>
            </Tooltip>
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Tooltip title="Close">
          <IconButton
            onClick={() => {
              console.log("Closing invite member modal");
              onClose();
            }}
          >
            <CloseIcon />
          </IconButton>
        </Tooltip>
      </DialogActions>
    </Dialog>
  );
};

export default InviteMemberModal;
